import { render, staticRenderFns } from "./APIs.vue?vue&type=template&id=4009fb3e"
import script from "./APIs.vue?vue&type=script&lang=js"
export * from "./APIs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports